import React from 'react';
//初始状态
export const initState = {
  actionId: 0, //用于列表页识别是哪个项次触发action
  refreshTs: 0, //用于触发重新加载数据
  showLoading: false,
  errorMsg: null,
  showDialog: false,
  showTip: false,
  tipMsg: null,
  dialogMsg: '',
  showQtyRevise: false,
  showUpload: false,
  showThreeDialog: false,
  threeDialogMsg: '',
  config: null,
  ok: () => {},
  cancel: () => {},
  update: () => {},
  noUpdate: () => {}
};

export function actionReducer(state: any, action: any) {
  switch (action.type) {
    case 'refresh':
      return {
        ...state,
        refreshTs: Date.now()
      };
    case 'showThreeConfirm':
      return {
        ...state,
        showThreeDialog: true,
        threeDialogMsg: action.content,
        update: action.update,
        noUpdate: action.noUpdate,
        cancel: action.cancel,
        updateText: action.updateText,
        noUpdateText: action.noUpdateText,
        cancelText: action.cancelText,
        title: action.title
      };
    case 'hideThreeDialog':
      return {
        ...state,
        showThreeDialog: false
      };
    case 'showConfirm':
      return {
        ...state,
        showDialog: true,
        dialogMsg: action.content,
        ok: action.ok,
        cnacel: action.cancel
      };
    case 'showReject':
      return {
        ...state,
        showReject: true,
        content: action.content,
        title: action.title,
        reasonStr: action.reasonStr,
        ok: action.ok,
        cnacel: action.cancel
      };
    case 'hideReject':
      return {
        ...state,
        showReject: false
      };
    case 'hideDialog':
      return {
        ...state,
        showDialog: false
      };
    case 'showError':
      return {
        ...state,
        errorMsg: action.errorMsg
      };
    case 'hideError':
      return {
        ...state,
        errorMsg: null
      };
    case 'showTip':
      return {
        ...state,
        showTip: true,
        showDialog: false,
        tipMsg: action.message
      };
    case 'hideTip':
      return {
        ...state,
        showTip: false
      };
    case 'showWfConfirm':
      return {
        ...state,
        actionId: action.actionId,
        showWfConfirm: true,
        showDialog: false
      };
    case 'hideWfConfirm':
      return {
        ...state,
        showWfConfirm: false
      };
    case 'showLoading':
      return {
        ...state,
        showLoading: true,
        showWfConfirm: false,
        showDialog: false
      };
    case 'hideLoading':
      return {
        ...state,
        showLoading: false
      };
    case 'showQtyRevise':
      return {
        ...state,
        showQtyRevise: true
      };
    case 'hideQtyRevise':
      return {
        ...state,
        showQtyRevise: false
      };
    case 'showUpload':
      return {
        ...state,
        config: action.config,
        showUpload: true
      };
    case 'hideUpload':
      return {
        ...state,
        showUpload: false
      };
    default:
      return state;
  }
}
export const ActionContext = React.createContext(initState);
